import CircleSelectComponent from './circle-select.component'

const CircleSelectModule = angular.module('cdbl.form.circle-select', [

])
  .component('cdblCircleSelect', CircleSelectComponent)
  .name

export default CircleSelectModule
